import {
  lesson7Assignment1,
  lesson7Assignment3,
  lesson7Assignment4
} from './assignments';
import { highlightCoordinates } from '../commonActivities'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_7/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    text: {
      data: 'Here\'s a hint, <br/>7 of them equal the Queen!',
      position: 'left',
      styleClass: 'sm',
      timeout: 5000
    },
    activity: {
      callback: lesson7Assignment1({
        next: 2
      }),
    },
    audio: { src: 'img/audio/lesson_7/1.mp3', start: true, controls: false },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Check the boxes <br/>for all the <br/>chess piece <br/>combinations <br/>equal to <br/>the Queen.`,
      timeout: 9000
    }
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_7/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>square the Queen <br/>could move to.`,
      timeout: 8000
    },
    text: {
      data: 'Remember, <br/>she only moves in straight lines',
      position: 'left',
      styleClass: 'md',
      timeout: 8000
    },
    audio: { src: 'img/audio/lesson_7/2.mp3', start: true, controls: false },
    chessboard: {
      board: highlightCoordinates({
        next: 4,
        showIndicators: { allSides: true },
        coordinates: ['.square-a2', '.square-b3', '.square-c4', '.square-a5', '.square-b5', '.square-c5', '.square-a8', '.square-b7', '.square-c6', '.square-d1', '.square-d2', '.square-d3', '.square-d4', '.square-d6', '.square-d7', '.square-d8', '.square-e4', '.square-f3', '.square-g2', '.square-h1', '.square-e5', '.square-f5', '.square-g5', '.square-h5', '.square-e6', '.square-f7', '.square-g8',],
        position: { d5: 'bQ' },
        coordinateClass: 'filled-cell',
        reminder: true,
      })
    }
  },
  {
    id: 4,
    previous: 2,
    next: 6,
    video: {
      src: 'img/videos/lesson_7/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 5,
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    audio: { src: 'img/audio/lesson_7/3.mp3', start: true, controls: false },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the <br/>Queen, then drag <br/>her to the <br/>piece you want her <br/>to capture. <br/>Remember, she <br/>must make <br/>a capture <br/>on every move.`,
      timeout: 12000
    },
    text: {
      data: "Here's a hint...<br/>the White King is the last piece you will capture.",
      position: 'left',
      styleClass: 'lg',
      timeout: 13000
    },
    chessboard: {
      board: lesson7Assignment4({
        showIndicators: { allSides: true },
        position: 'KB6/3N3N/7P/6Pq/7P/8/3R1R2/1B5k',
        assignmentClass: 'assignment-7-4 custom-sparepiece',
        next: 6
      }),
      positionFen: 'KB6/3N3N/7P/6Pq/7P/8/3R1R2/1B5k b - - 0 1',
    }
  },
  {
    id: 6,
    previous: 4,
    next: 8,
    video: {
      src: 'img/videos/lesson_7/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 7,
    }
  },
  {
    id: 7,
    previous: 6,
    next: 8,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the <br/>Black Queen, then <br/>drag her to the <br/>piece you want her <br/>to capture. <br/>Remember, she <br/>must make <br/>a capture <br/>on every move.`,
    },
    text: {
      data: "Here's a hint...<br/>the White Queen is the last piece you will capture.",
      position: 'left',
      styleClass: 'lg',
    },

    chessboard: {
      board: lesson7Assignment3({
        showIndicators: { allSides: true },
        position: '1P1N1N2/P6P/1P6/7k/8/R5P1/q2Q1B2/1R6',
        assignmentClass: 'assignment-7-3 custom-sparepiece',
        next: 8
      }),
      positionFen: '1P1N1N2/P6P/1P6/7k/8/R5P1/q2Q1B2/1R6 b - - 0 1',
    }
  },
  {
    id: 8,
    previous: 6,
    next: 9,
    video: {
      src: 'img/videos/lesson_7/5.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 9,
    }
  },
  {
    id: 9,
    previous: 8,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: "On which squares do the Queens start a game?",
      answer: [
        'e1 and e8',
        'e1 and d8',
        'd1 and e8',
        'd1 and d8'

      ],
      rightAnswer: 'd1 and d8',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 10,
    previous: 9,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: "What is the Queen's symbol?",
      answer: [
        'D',
        'Q',
        'A crown',
        'She has no symbol'
      ],
      rightAnswer: 'Q',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 9,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: "How many points is the Queen worth?",
      answer: [
        '5',
        '9',
        '7',
        '20'
      ],
      rightAnswer: '9',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 9,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "What is special about the Queen?",
      answer: [
        'She is the most powerful piece on the chessboard',
        'She can be demoted to a pawn',
        "She can move to any square she wants",
        'All of the above'
      ],
      rightAnswer: 'She is the most powerful piece on the chessboard',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'xl',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 13,
    previous: 9,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'How does the Queen move?',
      answer: [
        'In circles',
        'Four squares at a time',
        'Any direction in a straight line',
        'Wherever she wants'
      ],
      rightAnswer: 'Any direction in a straight line',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 14,
    previous: 9,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'How do Queens capture?',
      answer: [
        'By bumping a piece on a diagonal',
        'By bumping a piece along a file',
        'By bumping a piece along a rank',
        'All of the above'
      ],
      rightAnswer: 'All of the above',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 15,
    previous: 9,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'In the Middle Ages, Queens...',
      answer: [
        'Were the first line of defense in battle',
        'Were very powerful',
        'Rode horseback into every battle',
        'Were low ranking royalty'
      ],
      rightAnswer: 'Were very powerful',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 9,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    chessboard: {
      board: highlightCoordinates({
        isQA: true,
        showIndicators: { allSides: true },
        coordinates: ['.square-a4', '.square-b3', '.square-c2', '.square-d2', '.square-d3'],
        position: 'rnbqkbnr/1p3ppp/p1p1p3/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R',
        celebrationSound: false,
        coordinateClass: 'filled-square',
        reminder: true,
      }),
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>square where <br/>the White Queen <br/>could move.`
    }
  },
  {
    id: 17,
    previous: 9,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    chessboard: {
      board: highlightCoordinates({
        isQA: true,
        showIndicators: { allSides: true },
        coordinates: ['.square-a8', '.square-a5', '.square-b3', '.square-d2', '.square-h1'],
        position: 'R7/2p5/1p1kpBn1/R2q1p2/8/1N4P1/3PPP1P/5K1N',
        celebrationSound: false,
        coordinateClass: 'filled-square',
        reminder: true,
      }),
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on all the <br/>pieces the <br/>Black Queen <br/>could capture.`
    }
  },
  {
    id: 18,
    previous: 9,
    next: 19,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'Which chess pieces equal the Queen?',
      answer: [
        "1 Rook + 2 Knights",
        '1 Rook + 1 Knight + 1 Bishop',
        '1 Rook + 1 Bishop',
        '1 Rook + 4 pawns'
      ],
      rightAnswer: '1 Rook + 4 pawns',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 19,
    previous: 9,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Eight',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_6.png',
  '/img/background_7.png',
  '/img/background_8.png',
  '/img/box.png',
  '/img/tick.png',
  '/img/cross.png'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_7/index.js